import { FC, useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import {
  StatisticsWidget5,
  MixedWidget10,
  MixedWidget11,
} from '../../../_metronic/partials/widgets';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CurrencyContext } from '../../../_metronic/currency/CurrencyContextProvider';
import {
  FaShoppingCart,
  FaClipboardList,
  FaDollarSign,
  FaChartLine,
  FaUsers,
  FaBuilding,
  FaTags,
  FaBoxes,
  FaCheckCircle,
  FaTimesCircle,
  FaHourglassHalf,
} from 'react-icons/fa';

interface AdminData {
  today_orders: number;
  total_orders: number;
  total_sale: number;
  total_profit: number;
  today_sale: number;
  today_profit: number;
  total_resellers: number;
  total_companies: number;
  total_services: number;
  total_bundles: number;
  balances_by_currency: Array<{ currency_code: string; total_balance: number }>;
  today_pending: number;
  today_success: number;
  today_rejected: number;
  pending_orders:number;
  rejected_orders:number;
  successful_orders:number;
  today_pending_orders:number;
  today_rejected_orders:number;
  today_successful_orders:number;}

const DashboardPage: FC = () => {
  const API_URL = process.env.REACT_APP_THEME_API_URL;
  const DASHBOARD_URL = `${API_URL}/admin/dashboard`;
  const intl = useIntl();
  const [adminData, setAdminData] = useState<AdminData | null>(null);
  const currencyContext = useContext(CurrencyContext);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(DASHBOARD_URL)
      .then((response) => {
        const data = response.data;
        if (data.success) {
          setAdminData(data.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleCardClick = (status: string,url:string) => {
    navigate(url, { state: { status } });
  };

  return (
    <>
      {/* Orders Cards */}
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaShoppingCart />}
            color='primary'
            iconColor='white'
            titleColor='black'
            descriptionColor='white'
            title={adminData ? adminData.today_orders.toString() : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TODAYORDER' })}
            onClick={() => handleCardClick('',`/admin/pages/orders`)}
          />
        </div>

        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaClipboardList />}
            color='primary'
            iconColor='white'
            titleColor='black'
            descriptionColor='white'
            title={adminData ? adminData.total_orders?.toString() : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TOTALORDER' })}
            onClick={() => handleCardClick('',`/admin/pages/orders`)}

          />
        </div>

 {/* Pending Orders */}
      <div className='col-xl-2 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaHourglassHalf />}
            color='warning'
            iconColor='white'
            titleColor='black'
            descriptionColor='white'
            title={adminData ? adminData.pending_orders?.toString() : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.PENDINGORDERS' })}
            todayText={intl.formatMessage({ id: 'DASHBOARD.TODAY', defaultMessage:"Today" })}
            todayValue={adminData?.today_pending_orders?.toString() || '0'}
            onClick={() => handleCardClick('0',`/admin/pages/orders`)}
          />
        </div>

        {/* Success Orders */}
        <div className='col-xl-2 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaCheckCircle />}
            color='success'
            iconColor='white'
            titleColor='black'
            descriptionColor='white'
            title={adminData ? adminData.successful_orders?.toString() : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.SUCCESSORDERS' })}
            todayText={intl.formatMessage({ id: 'DASHBOARD.TODAY', defaultMessage:"Today" })}
            todayValue={adminData?.today_successful_orders?.toString() || '0'}
            onClick={() => handleCardClick('1',`/admin/pages/orders`)}
          />
        </div>

        {/* Rejected Orders */}
        <div className='col-xl-2 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaTimesCircle />}
            color='danger'
            iconColor='white'
            titleColor='black'
            descriptionColor='white'
            title={adminData ? adminData.rejected_orders?.toString() : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.REJECTEDORDERS' })}
            todayText={intl.formatMessage({ id: 'DASHBOARD.TODAY', defaultMessage:"Today" })}
            todayValue={adminData?.today_rejected_orders?.toString() || '0'}
            onClick={() => handleCardClick('2',`/admin/pages/orders`)}
          />
        </div>
      </div>

      {/* Sales and Profit Cards */}
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaDollarSign />}
            color='white'
            iconColor='primary'
            title={adminData ? `${currencyContext.symbol} ${adminData.today_sale.toFixed(2)}` : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TODAYSALE' })}
          />
        </div>

        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaChartLine />}
            color='white'
            iconColor='primary'
            title={adminData ? `${currencyContext.symbol} ${adminData.today_profit.toFixed(2)}` : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TODAYPROFIT' })}
          />
        </div>

        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaDollarSign />}
            color='secondary'
            iconColor='primary'
            titleColor='black'
            descriptionColor='primary'
            title={adminData ? `${currencyContext.symbol} ${adminData.total_sale.toFixed(2)}` : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TOTALSALE' })}
          />
        </div>

        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaChartLine />}
            color='secondary'
            iconColor='primary'
            titleColor='black'
            descriptionColor='primary'
            title={adminData ? `${currencyContext.symbol} ${adminData.total_profit.toFixed(2)}` : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TOTALPROFIT' })}
          />
        </div>
      </div>

      {/* Resellers, Companies, Services, Bundles */}
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaUsers />}
            color='success'
            iconColor='white'
            titleColor='black'
            descriptionColor='white'
            title={adminData ? adminData.total_resellers.toString() : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TOTALRESELLER' })}
            onClick={() => handleCardClick('',`/admin/pages/resellers`)}

          />
        </div>

        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaBuilding />}
            color='success'
            iconColor='white'
            titleColor='black'
            descriptionColor='white'
            title={adminData ? adminData.total_companies.toString() : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TOTALCOMPANY' })}
            onClick={() => handleCardClick('',`/admin/pages/companies`)}
          />
        </div>

        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaTags />}
            color='secondary'
            iconColor='primary'
            titleColor='black'
            descriptionColor='primary'
            title={adminData ? adminData.total_services.toString() : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TOTALSERVICE' })}
            onClick={() => handleCardClick('',`/admin/pages/services`)}

          />
        </div>

        <div className='col-xl-3 col-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            icon={<FaBoxes />}
            color='secondary'
            iconColor='primary'
            titleColor='black'
            descriptionColor='primary'
            title={adminData ? adminData.total_bundles.toString() : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
            description={intl.formatMessage({ id: 'DASHBOARD.TOTALBUNDLE' })}
            onClick={() => handleCardClick('',`/admin/pages/bundles`)}

          />
        </div>
     
      </div>
      <hr />
    <h1>{intl.formatMessage({ id: 'DASHBOARD.BALANCES' })}</h1>
    <span className='hint'>{intl.formatMessage({ id: 'DASHBOARD.BALANCES.HINT' })}</span>
    <hr />
      <div className='row g-5 g-xl-8'>
        {adminData?.balances_by_currency.map((bbc:any)=>(
                  <div className='col-xl-3 col-6'>
                  <StatisticsWidget5
                    className='card-xl-stretch mb-xl-8'
                    icon={<FaDollarSign />}
                    color='info'
                    iconColor='white'
                    titleColor='black'
                    descriptionColor='white'
                    title={bbc ? bbc.total_balance : intl.formatMessage({ id: 'APP.GENERAL.LOADING' })}
                    description={bbc.currency_code}
                  />
                </div>
        ))}
      </div>

      <hr />
      <div className='row g-5 g-xl-8'>
      <div className='col-xxl-6'>
        <MixedWidget10
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='150px'
        />
        <MixedWidget11
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='175px'
        />
      </div>
      <div className='col-xxl-6'>
        <MixedWidget10
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='150px'
        />
        <MixedWidget11
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='175px'
        />
      </div>
      </div>
    </>
  );
};

const DashboardWrapper: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  );
};

export { DashboardWrapper };
